export const ticketFieldSort = [
  { code: 'createdDate', name: 'Ngày tạo' },
  { code: 'createdById', name: 'Người tạo' }
];
